import { Button, Group } from '@mantine/core';

import { IconUpload } from '@tabler/icons-react';
import docStatusMap from '../constants/docStatusMap';

export function ViewButtonComponent({ view, processCasses, failCasses }) {
  let buttons = <></>;
  if (view === docStatusMap.batchQ) {
    buttons = (
      <Group justify="space-between">
        <Button
          variant="filled"
          color="green.7"
          leftIcon={<IconUpload size={18} />}
          onClick={processCasses}>
          PROCESS NOW
        </Button>
      </Group>
    );
  }
  if (view === docStatusMap.completeQ) {
    <>
      <Button
        variant="gradient"
        gradient={{ from: 'teal', to: 'blue', deg: 60 }}
        onClick={processCasses}>
        GENERATE CSV
      </Button>
    </>;
  }
  return <>{buttons}</>;
}
